exports.bdd = require('./bdd');
exports.tdd = require('./tdd');
exports.qunit = require('./qunit');
exports.exports = require('./exports');



/*****************
 ** WEBPACK FOOTER
 ** ./~/mocha/lib/interfaces/index.js
 ** module id = 130
 ** module chunks = 1
 **/